window.bm.HandbookSearchViewModel = function (initialJsonData, showingResultsFormat) {
  var self = this;

  self.Name = 'HandbookSearchViewModel';

  self.HandbookSearchResultData = ko.observable(null);
  self.IsSearchRunning = ko.observable(false);
  self.IsResultModelInitialized = ko.observable(false);
  self.TypeAheadFilter = ko.observable('');


  // Display Field For (showing results {0} of {1} ect.....)
  self.ShowingResultsFormat = ko.computed(function () {
    if (!!self.HandbookSearchResultData()) {
      return showingResultsFormat.replace('{0}', self.HandbookSearchResultData().searchResults().length).replace('{1}', self.HandbookSearchResultData().resultCount()) + ' for ';
    }
    return '';
  });
  self.DisplaySearchTerm = ko.computed(function () {
    self.IsSearchRunning();
    var searchTerm = self.TypeAheadFilter.peek();
    return "'" + searchTerm + "'";
  });

  self.BackToDefaultView = function () {
    var qs = "?view=default";
    History.pushState({ qs: qs }, History.options.initialTitle, qs);
    self.TypeAheadFilter('');
  };

  self.Load = function (initialJson) {
    self.IsSearchRunning(true);
    var qsParms = self.parseQueryString(window.location.href);
    if (!!qsParms) {
      if (!!qsParms.query && qsParms.query.length > 0) {
        self.TypeAheadFilter(qsParms.query);
      }
    }
    self.HandbookSearchResultData(new HandbookSearchResults(initialJson));
    self.IsSearchRunning(false);
  };

  // Build query string based on filters
  self.QueryString = function () {
    var queryString = "?view=search";

    if (self.HandbookSearchResultData().searchFilters.query() != null && self.HandbookSearchResultData().searchFilters.query().length > 0) {
      queryString += (queryString != "" ? "&" : "?");
      queryString += "query=" + encodeURIComponent(self.HandbookSearchResultData().searchFilters.query());
    }
    if (self.HandbookSearchResultData().searchFilters.skip() > 0) {
      queryString += (queryString != "" ? "&" : "?");
      queryString += "skip=" + self.HandbookSearchResultData().searchFilters.skip();
    }
    queryString += (queryString != "" ? "&" : "?");
    queryString += "scroll=" + $(window).scrollTop();

    return queryString;
  };

  self.parseQueryString = function (str) {
    if (typeof str !== 'string') {
      return {};
    }
    var strArr = str.trim().split('?');
    if (!strArr || strArr.length < 2) {
      return {};
    }
    str = strArr[1];
    return str.trim().split('&').reduce(function (ret, param) {
      var parts = param.replace(/\+/g, ' ').split('=');
      ret[parts[0]] = parts[1] === undefined ? null : decodeURIComponent(parts[1]);
      return ret;
    }, {});
  };

  // Run search by pushing new state
  self.Search = function () {
    if (!!self.HandbookSearchResultData) {
      if ((self.TypeAheadFilter().trim().length > 0) && (self.TypeAheadFilter().trim() !== self.HandbookSearchResultData().searchFilters.query())) {
        self.HandbookSearchResultData().searchFilters.query(self.TypeAheadFilter().trim());
        self.HandbookSearchResultData().searchResults([]);
        self.HandbookSearchResultData().resultCount(0);
        self.HandbookSearchResultData().hasMoreResults(false);
        self.HandbookSearchResultData().searchFilters.skip(0);
        var qs = self.QueryString();
        History.pushState({ qs: qs }, History.options.initialTitle, qs);
      }
    } else {
      self.TypeAheadFilter('');
    }
  };

  // Load next page
  self.LoadNextPage = function () {
    self.HandbookSearchResultData().searchFilters.skip(self.HandbookSearchResultData().searchResults().length);
    var qs = self.QueryString();
    History.pushState({ qs: qs }, History.options.initialTitle, qs);
  };

  // Load data from server
  self.LoadDataFromServer = function () {
    self.IsSearchRunning(true);

    $.ajax({
      url: '/api/handbook/search',
      type: "GET",
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      data: self.HandbookSearchResultData().searchFilters,
      cache: false,
      success: function (data) {
        if (self.HandbookSearchResultData().searchFilters.skip() == 0) {
          self.HandbookSearchResultData().resultCount(0);
          self.HandbookSearchResultData().searchResults([]);
        }
        var newHandbookResultData = new HandbookSearchResults(data);
        var oldResults = self.HandbookSearchResultData().searchResults();

        newHandbookResultData.searchResults(oldResults.concat(newHandbookResultData.searchResults()));
        self.HandbookSearchResultData(newHandbookResultData);

        self.TypeAheadFilter(data.searchFilters.query);

        self.IsSearchRunning(false);
        $('#HandbookSearchInput').blur();

      },
      error: function (xhr, textStatus, errorThrown) {
        console.log(xhr);
        console.log("textStatus : " + textStatus);
        console.log("errorThrown : " + errorThrown);
      }
    });
  }

  self.Load(initialJsonData);
};
ko.bindingHandlers.BindTopicTileHover = {

  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    $(element).on('mouseenter', function () {
      var currentHeight = $(this).parent().height();
      $(this).addClass('tile-hovered');
      $(this).parent().css('height', currentHeight + 'px');

    });
    $(element).on('mouseleave', function () {
      $(this).parent().css('height', 'auto');
      $(this).removeClass('tile-hovered');
    });
  }
};
ko.bindingHandlers.SearchEnterkey = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var callback = valueAccessor();
    $(element).keypress(function (event) {
      var keyCode = (event.which ? event.which : event.keyCode);
      if (keyCode === 13) {
        callback.call(viewModel);
        $(element).blur();
        return false;
      }
      return true;
    });
    $(window).blur(function () {
      $(element).blur();
    });
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
  }
};
ko.bindingHandlers.bindAutoComplete = {
  init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
    var acInput = $(element);
    var observable = valueAccessor();
    var allBindings = allBindingsAccessor();
    var root = bindingContext.$root;

    var autoCompleteSection = allBindings.bindAutoCompleteSection;
    var autoCompleteField = allBindings.bindAutoCompleteField;
    var autoCompleteMaxResults = 7;
    if (!!allBindings && !!allBindings.bindAutoCompleteMaxResults && allBindings.bindAutoCompleteMaxResults != '') {
      autoCompleteMaxResults = allBindings.bindAutoCompleteMaxResults;
    }
    var autoCompleteUrl = allBindings.bindAutoCompleteServiceUrl;
    var autoCompleteAppendTo = allBindings.bindAutoCompleteAppendTo;

    var appendTo = null
    if (!!autoCompleteAppendTo && autoCompleteAppendTo != '') {
      appendTo = $(autoCompleteAppendTo);
    }

    var pattern, formattedResult, termArry;
    // Copied From jquery.autocomplete.js for custom formatting
    var
      utils = (function () {
        return {
          escapeRegExChars: function (value) {
            return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
          },
          createNode: function (containerClass) {
            var div = document.createElement('div');
            div.className = containerClass;
            div.style.position = 'absolute';
            div.style.display = 'none';
            return div;
          }
        };
      }()),

      keys = {
        ESC: 27,
        TAB: 9,
        RETURN: 13,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
      };

    var ac = acInput.autocomplete({
      maxHeight: '100%',
      appendTo: appendTo,
      zIndex: 150,
      serviceUrl: autoCompleteUrl,
      noCache: true,
      minChars: 3,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      triggerSelectOnValidInput: false,
      params: { field: autoCompleteField, take: autoCompleteMaxResults, handbookId: root.HandbookId() },
      onSelect: function (value) {
        window.location.href = value.url;
      },
      transformResult: function (response, originalQuery) {
        var autoCompleteResultCount = 0;
        return {
          suggestions: $.map(response, function (dataItem) {
            if (autoCompleteResultCount < autoCompleteMaxResults) {
              autoCompleteResultCount++;
              return { url: dataItem.Url, value: dataItem.Name };
            }
            return [];
          })
        };
      },
      formatResult: function (suggestion, currentValue) {
        termArry = currentValue.replace(/"/gi, '').replace(/”/gi, '').replace(/“/gi, '').split(' ');
        if (termArry.length > 0) {
          //sort terms longest to shortest for multiple search terms that may start with same letters (i.e. searching John J)
          termArry = termArry.sort(function (a, b) {
            return b.length - a.length;
          });
          formattedResult = suggestion.value;
          pattern = '';
          for (var i = 0; i < termArry.length; i++) {
            var keyTerm = termArry[i].trim().replace(/"/gi, '');
            if (keyTerm.length > 0) {
              //Matching start of string or matching start of word including all characters or matching start of word surrounded in quotes
              //Ignores span tag and class if already replaced
              pattern = '((\\s' + utils.escapeRegExChars(keyTerm) + ')|(^' + utils.escapeRegExChars(keyTerm) + ')|(\\s"' + utils.escapeRegExChars(keyTerm) + '))(?![^<>]*>)';
              formattedResult = formattedResult.replace(new RegExp(pattern, 'gi'), '<span class="auto-term">$1<\/span>');
            }
          }
        }

        return "<span class='label'>" + formattedResult + "</span>";
      },
      onSearchStart: function (params) {
        if (params.query.trim().length < 3) {
          return false;
        } else {
          params.query = params.query.trim()
        }
      }
    });
  }
}